/**
 * Safely parses a JSON string.
 * Returns the default value if parsing fails or input is null/undefined.
 */
import { globalSnackbar } from "./snackbarUtils";

export const safeJsonParse = <T>(
  jsonString: string | null | undefined,
  defaultValue: T,
  context: string = "Data",
): T => {
  if (!jsonString) return defaultValue;
  try {
    return JSON.parse(jsonString) as T;
  } catch (error) {
    console.warn(`Failed to parse JSON safely [${context}]:`, error, {
      jsonString,
    });
    globalSnackbar.enqueueSnackbar(`Data Error: Unable to load ${context}`, {
      variant: "error",
      autoHideDuration: 3000,
    });
    return defaultValue;
  }
};

/**
 * Safely accesses a nested object property via a path.
 * Alternative to optional chaining if needed, but primarily useful for dynamic paths.
 */
export const getSafe = (
  obj: any,
  path: string,
  defaultValue: any = undefined,
) => {
  const travel = (regexp: RegExp) =>
    path
      .split(regexp)
      .filter(Boolean)
      .reduce(
        (res, key) => (res !== null && res !== undefined ? res[key] : res),
        obj,
      );
  const result = travel(/[,[\]]+| \./g);
  return result === undefined || result === obj ? defaultValue : result;
};
